//types
export const BOREHOLE_LIST = 'SUBSURFACE/BOREHOLE/List';
export const BOREHOLE_ROCK_LIST = 'SUBSURFACE/BOREHOLE_ROCK/List';
export const BOREHOLE_ROCK_COLOR_LIST = 'SUBSURFACE/BOREHOLE_ROCK_COLOR/List';

export const setBoreholeList = boreholeList => ({ type: BOREHOLE_LIST, boreholeList });

export const setRockTypeList = (rockList, boreholeKey) => ({ type: BOREHOLE_ROCK_LIST, rockList, boreholeKey });

export const setRockTypeColorList = (rockColorList) => ({ type: BOREHOLE_ROCK_COLOR_LIST, rockColorList });